import React,{ createContext, useContext, useState } from "react";
import useInitialState from "../hooks/useInitialState";

export const RCContext = createContext();


export const RCProvider = ({children}) => {
    const initialState = useInitialState()
    return <RCContext.Provider value={initialState}>
        {children}
    </RCContext.Provider>
}

export const useRCContext = () => {
    
    const context = useContext(RCContext)
    if(context === undefined){
        throw new Error('ReembolsoComercio must be used within a ReembolsoComercioProvider')
    }
    return context
}